import React, { useEffect, useState } from 'react';
import useFetchReports from './useFetchReports';
import { GetPacReport } from '../Adapters/GetPacReport';
import Dexie from 'dexie';
import { GetPacReportOnlyImages } from '../Adapters/GetPacReportOnlyImages';

const db = new Dexie('imgEditorDb');
db.version(1).stores({
  images: 'id,image',
  previewImages: 'id,image',
});

const useHandlePageData = (keyConfer, isPacs) => {
  // console.log('key confer is =>', keyConfer);

  const [existingPreview, setExistingPreview] =
    useState(null);

  const fetchFromIndexedDb = async () => {
    const existingPreview = await db.previewImages.get(314);
    setExistingPreview(existingPreview);
  };

  useEffect(() => {
    fetchFromIndexedDb();
  }, []);

  const [pacsData, setPacsData] = useState(null);

  const reportsData = useFetchReports(keyConfer);
  useEffect(() => {
    if (!existingPreview?.id) {
      console.log('reportsData--->', reportsData);
      if (!reportsData) {
        return;
      }
      if (reportsData[0] && isPacs) {
        GetPacReportOnlyImages(reportsData[0], setPacsData);
        GetPacReport(reportsData[0], setPacsData);
      }
    }
  }, [
    JSON.stringify(reportsData),
    keyConfer,
    isPacs,
    existingPreview,
  ]);

  return [reportsData, pacsData];
};

export default useHandlePageData;
